/* Capsule opening driven by scroll (2026-10-16, Mike: "as they scroll it animates, and if they stop it stops").
   A sequence of still frames drawn on a canvas, so it is smooth on phones too (video seeking stutters on iOS). No pinning:
   the opening runs while the figure travels from the bottom of the screen to about a third of the way down, then the numbered
   labels fade in. Scrolling back up reverses it. Reduced motion, or frames that fail to load: the labelled still. */
(() => {
  const fig = document.querySelector(".c9cap [data-cap][data-seq]");
  if (!fig) return;
  const media = fig.querySelector(".cap-media");
  const urls = JSON.parse(fig.dataset.seq || "[]");
  const showStill = () => { fig.classList.remove("scrub-ready"); fig.classList.add("done"); };
  if (!urls.length || matchMedia("(prefers-reduced-motion: reduce)").matches) { showStill(); return; }

  const cv = document.createElement("canvas");
  cv.className = "cap-canvas"; cv.setAttribute("aria-hidden", "true");
  media.appendChild(cv);
  const ctx = cv.getContext("2d");
  const frames = new Array(urls.length);
  let loaded = 0, started = false, last = -1, raf = 0;

  const size = () => {
    const r = media.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    const w = Math.round(r.width * d), h = Math.round(r.height * d); if (w === cv.width && h === cv.height) return;  /* iOS fires resize whenever the address bar moves */
    cv.width = w; cv.height = h; last = -1; draw();
  };
  const progress = () => {
    const r = fig.getBoundingClientRect(), vh = innerHeight;
    // keyed to the figure's centre. Mike: "too early and too fast", then "doesn't finish by middle": starts as the capsule comes up
    // from the bottom (centre at the bottom edge) and is fully open, labels on, when it reaches the middle of the screen.
    // Lightly eased, because the source video does most of its opening early.
    const c = r.top + r.height / 2;
    const raw = Math.max(0, Math.min(1, (vh * 1.0 - c) / (vh * 0.5)));
    return Math.pow(raw, 1.3);
  };
  const nearest = (i) => {  // closest loaded frame, so a slow connection never shows a blank
    for (let k = 0; k < frames.length; k++) {
      if (frames[i - k] && frames[i - k].naturalWidth) return frames[i - k];
      if (frames[i + k] && frames[i + k].naturalWidth) return frames[i + k];
    }
    return null;
  };
  function draw() {
    raf = 0;
    if (!loaded) return;
    const p = progress(), i = Math.round(p * (urls.length - 1));
    fig.classList.toggle("done", p >= 0.97);
    if (i === last) return;
    const img = nearest(i); if (!img) return;
    last = i;
    ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.drawImage(img, 0, 0, cv.width, cv.height);
  }
  const request = () => { if (!raf) raf = requestAnimationFrame(draw); };
  const load = () => {
    if (started) return; started = true;
    // first frame, last frame, then the rest in order, so the start and the labelled end are ready first
    const order = [0, urls.length - 1].concat(urls.map((_, k) => k).slice(1, -1));
    order.forEach((k) => {
      const im = new Image(); im.decoding = "async"; im.src = urls[k];
      im.onload = () => { loaded++; if (loaded === 1) { fig.classList.add("scrub-ready"); size(); } request(); };
      im.onerror = () => { if (k === 0) showStill(); };
      frames[k] = im;
    });
  };
  new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: "900px 0px" }).observe(fig);
  addEventListener("scroll", request, { passive: true });
  addEventListener("resize", size);
})();
